import React from 'react';
import config from 'appconfig';
import { StyledLink, StyledSpan } from '../StyledComponents';
import { Dimensions } from 'components/visuals';
import { messages } from 'modules/mac/messages';
import { FormattedMessage } from 'react-intl';
import { ATLASSIAN_ORGANISATION, CloudProductKeys } from 'data/products/keys';
import { StyledPipe } from '../ActionsSectionElements/StyledPipe';
import { DetailsRow } from './DetailsRow';

const PaymentDetailsSection = ({
  accountDetails: {
    creditCardData,
    latestPeriod,
    txAMigrated,
    entSubMigrated,
    productsBilledInCCP,
    externalUuid,
    id,
    merchandise: {
      productPackage: { hostingType, key },
    },
  },
  productKey,
}) => {
  const isCloud = hostingType === 'HOSTED';
  const isBB = key === CloudProductKeys.BITBUCKET;
  const shouldBlockEditProvideCCDetails = isCloud && !isBB;
  const card = creditCardData;

  const provideEditCCMessage =
    new Date(latestPeriod.endDate) > new Date()
      ? messages.editCreditCard
      : messages.providePaymentDetails;

  const orgOrSiteValue = productKey !== ATLASSIAN_ORGANISATION ? 's' : 'o';

  const pageURLPart =
    card && new Date(latestPeriod.endDate) > new Date() ? 'update-credit-card' : 'payment-details';

  const paymentDetailsLink =
    txAMigrated || entSubMigrated || productsBilledInCCP
      ? `${config.adminHubUrl}/${orgOrSiteValue}/${externalUuid}/billing/paymentdetails`
      : `${config.root}/my/${pageURLPart}/${id}`;

  return (
    <DetailsRow
      label={<FormattedMessage {...messages.paymentMethod} />}
      value={
        card ? (
          <>
            {card?.gateway === 'BRAINTREE_PAYPAL' ? (
              <StyledSpan data-cy="card-details" $padding={`0 ${Dimensions.units(0.5)}px 0 0`}>
                {`PAYPAL - ${card.name}`}
              </StyledSpan>
            ) : (
              <>
                <StyledSpan data-cy="card-details" $padding={`0 ${Dimensions.units(0.5)}px 0 0`}>
                  {`${card.type} - ${card.maskedNumber} (${card.expiryMonth}/${card.expiryYear}) - ${card.name}`}
                </StyledSpan>
                {!shouldBlockEditProvideCCDetails && (
                  <>
                    <StyledPipe />
                    <StyledLink href={paymentDetailsLink}>
                      <FormattedMessage {...provideEditCCMessage} />
                    </StyledLink>
                  </>
                )}
              </>
            )}
          </>
        ) : (
          !shouldBlockEditProvideCCDetails && (
            <StyledLink data-cy="add-payment-method-btn" href={paymentDetailsLink || ''}>
              <FormattedMessage {...messages.providePaymentDetails} />
            </StyledLink>
          )
        )
      }
    />
  );
};

export default PaymentDetailsSection;
